// extracted by mini-css-extract-plugin
export default {"EV54Alarms_container":"EV54Alarms_EV54Alarms_container__ydSqK","EV54Alarms_row":"EV54Alarms_EV54Alarms_row__0s8RK"};